import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _Math$trunc from "@babel/runtime-corejs3/core-js/math/trunc";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SectionError from "./section-error.vue";
import TextSection from "./text-section.vue";
import i18n from "@Shared/@i18n/";
import { get } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "YearsMonthsSection",
  components: {
    TextSection,
    SectionError
  },
  provide() {
    //mostly needed for address custom section - but can be augmented
    if (this.$validator && this.appendValidatorPath) {
      return {
        $validator: {
          value: this.$validator.value[this.name]
        }
      };
    }
  },
  inject: {
    $validator: {
      default: null
    },
    $rootValidator: {
      default: null
    }
  },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: {
      type: null,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tabindex: {
      type: [Number, String],
      default: 0
    },
    required: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: () => i18n.t("application-form.time-at")
    },
    hideLabels: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ""
    },
    appendValidatorPath: {
      type: Boolean,
      default: false
    },
    path: {
      type: String,
      default: ""
    },
    forceZeroPlaceholder: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return this.parseValue();
  },
  computed: {
    placeholderText() {
      const regex = new RegExp(`(\\(${this.$t("global.phrases.inMonths")}\\)|\\((${this.$t("global.phrases.inYears")})\\))`);
      return this.placeholder.replace(regex, "");
    },
    groupValidator() {
      var _this$$rootValidator;
      const validationPath = this.path.replace(/\[(\d*)\]$/g, "").replace(/\[(\d*)\]/, "[$each][$1]");
      const rootValidator = (_this$$rootValidator = this.$rootValidator) == null ? void 0 : _this$$rootValidator.value;
      if (!rootValidator) return null;
      const rootModel = rootValidator.applicationValidationsModel;
      return get(rootModel, validationPath) || {};
    }
  },
  watch: {
    months(value) {
      this.$nextTick(() => {
        if (!value && this.forceZeroPlaceholder) this.months = "0";
      });
    },
    years(value) {
      this.$nextTick(() => {
        if (!this.months) {
          if (value) this.months = 0;else this.months = "";
        }
        if (!value && this.forceZeroPlaceholder) this.years = "0";
      });
    },
    value() {
      this.$nextTick(() => {
        const data = this.parseValue();
        this.years = data.years;
        this.months = data.months;
      });
    }
  },
  methods: {
    handleChange() {
      const monthsValue = _parseInt(this.years || 0) * 12 + _parseInt(this.months || 0);
      this.$emit("change", monthsValue);
    },
    monthRest(months) {
      return months % 12;
    },
    yearsRest(months) {
      return _Math$trunc(months / 12);
    },
    parseValue() {
      const initialMonths = _parseInt(this.value);
      const months = this.monthRest(initialMonths) || 0;
      const years = this.yearsRest(initialMonths) || 0;
      return {
        years,
        months
      };
    }
  }
});